import MapLink from "./MapLink";

export default MapLink;
